import { getPublicProfile, GetPublicProfileApiParameter, MyPublicProfileModel, MyPublicProfileResult } from "@dana/Services/DanaMyPublicProfileService";
import { MyPublicProfileActions } from "@dana/Store/Data/MyPublicProfile/Reducers/MyPublicProfileReducer";
import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";

import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<GetPublicProfileApiParameter, MyPublicProfileResult, DispatchProp<MyPublicProfileActions>>;

export const DispatchBeginLoadAccount: HandlerType = props => {
    props.dispatch({
        type: "MyPublicProfile/BeginLoad",
        isLoading: true,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        userName: props.parameter.userName,
        customerId: props.parameter.customerId
    };
};

export const GetPublicProfile: HandlerType = async props => {
    props.apiResult = await getPublicProfile(props.apiParameter);
};

export const DispatchCompleteLoadProfile: HandlerType = props => {
    props.dispatch({
        type: "MyPublicProfile/CompleteLoadProfile",
        myPublicProfile: props.apiResult?.publicProfile,
    });
};
export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "MyPublicProfile/EndLoad",
        isLoading: false,
    });
}

export const chain = [
    DispatchBeginLoadAccount,
    PopulateApiParameter,
    GetPublicProfile,
    DispatchCompleteLoadProfile,
    SetLoadingOff
];
const loadMyPublicProfile = createHandlerChainRunner(chain, "MyPublicProfileHandler");
export default loadMyPublicProfile;
